'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './contact-list.routes';

export class ContactListComponent {
  constructor(Auth, ContactService, dialogs, DTOptionsBuilder, DTDefaultOptions, DTState, DTColumnBuilder, SettingsService) {
    'ngInject';

    console.time();

    this.ContactService = ContactService;
    this.data = [];

    this.dialogs = dialogs;

    this.valueMap = {
      composedNameHtml: {},
      primaryAddressHtml: {},
      primaryPhone: {},
      primaryEmail: {},
      primaryEmailHtml: {}
    };

    DTDefaultOptions.setLoadingTemplate( "<datatable-loading-placeholder columns='Loading..., Name, Address, Phone, Mail, Creation Date' />");

    SettingsService.getByName({name: 'config.app'}, settings => {
      let ssDT = settings.data.serverSideDT || {};
      this.serverSideDT = ssDT && ssDT.contacts && ssDT.contacts.enabled;

      const that = this;

      if (this.serverSideDT) {

        this.dtColumns = [
          //here We will add .withOption('name','column_name') for send column name to the server
          DTColumnBuilder.newColumn("lastName", "Name").withOption('name', 'Name')
          //DTColumnBuilder.newColumn("firstName", "First").withOption('name', 'First'),
          //DTColumnBuilder.newColumn("lastName", "Last").withOption('name', 'Last')
        ];

        this.dtOptionsSS = DTOptionsBuilder.newOptions()
          //.withOption('dom', 'lBfrtip')
          .withOption('serverSide', true)
          //.withOption('processing', true)
          //.withDataProp('data')
          .withOption('stateSave', true)
          .withOption('stateSaveCallback', DTState.save())
          .withOption('stateLoadCallback', DTState.restore())
          .withOption('pagingType', 'full_numbers')
          .withOption('pageLength', 10)
          .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
          //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
          .withOption('ajax', (params, cb) => {

            if (params.search) {
              if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
                return;

              params.search.fields = ["lastName, firstName", "firstName", "lastName", "company", "address.street", "email.address"];
            }

            that.ContactService.queryDT(params, result => {
              if (params.search && params.search.value) {
                let searchTerms = params.search.value.split(",").map(t => t.trim());
                that.buildValueMap(result.data, true, searchTerms);
              } else {
                that.buildValueMap(result.data);
              }

              that.data = result.data;

              cb({
                recordsTotal: result.recordsTotal,
                recordsFiltered: result.recordsFiltered,
                data: []
              })
            })
          });

        this.ssInitReady = true;
      } else {

        this.dtOptions = DTOptionsBuilder.newOptions()
          .withOption('dom', 'lBfrtip')
          .withOption('order', [0, 'asc'])
          .withOption('deferRender', true)
          .withOption('initComplete', _ => {
            this.initComplete = true;
            console.timeEnd();
          })
          .withOption('stateSave', true)
          .withOption('stateSaveCallback', DTState.save())
          .withOption('stateLoadCallback', DTState.restore())
          .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
          .withOption('aaSorting', [0, 'asc']) // for default sorting column // here 0 means first column
          .withOption('buttons', [{
            extend: 'excel',
            title: "Contacts"
          }, {
            extend: 'csv',
            title: "Contacts"
          }, {
            title: "Contacts",
            message: 'As of ' + moment().format("MMMM Do YYYY"),
            extend: 'pdf',
            orientation: 'portrait',
            pageSize: 'LETTER'
          }, {
            extend: 'print',
            title: "Contacts"
          }]);

        this.ContactService.query(data => {
          this.data = data;
          this.buildValueMap(data);
          this.dataInitComplete = true;
        }, err => {
          console.log("Could not retrieve contacts.");
        });
      }
    });
  }

  buildValueMap(data, highlight, searchTerms) {
    data.forEach(contact => {
      this.valueMap.composedNameHtml[contact._id] = this.getComposedName(contact);
      this.valueMap.primaryAddressHtml[contact._id] = this.getPrimaryAddress(contact);
      this.valueMap.primaryPhone[contact._id] = this.getPrimaryPhone(contact);
      this.valueMap.primaryEmail[contact._id] = this.getPrimaryEmail(contact);
      this.valueMap.primaryEmailHtml[contact._id] = this.getPrimaryEmailSoftBreak(contact);

      if (highlight && searchTerms && searchTerms.length) {
        searchTerms.sort(function(a, b) {
          return b.length - a.length;
        });

        var regexFirst = new RegExp(searchTerms[0], 'i');
        var regexAll = new RegExp('(' + searchTerms.join('|') + ')', 'gi');

        this.valueMap.composedNameHtml[contact._id] = this.valueMap.composedNameHtml[contact._id].replace(regexAll, '<b>$&</b>');
        this.valueMap.primaryAddressHtml[contact._id] = this.valueMap.primaryAddressHtml[contact._id].replace(regexFirst, '<b>$&</b>');
        this.valueMap.primaryEmailHtml[contact._id] = this.valueMap.primaryEmailHtml[contact._id].replace(regexFirst, '<b>$&</b>');
      }
    });
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
          composedName = "-, -";

        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }

  getPrimaryEmailSoftBreak(contact) {
    let email = this.getPrimaryEmail(contact);

    return email
      .replace('@','@&#8203;')
      .replace('.','&#8203;.')
      .replace('-','-&#8203;')
      .replace('_','_&#8203;');
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  getPrimaryPhone(contact) {
    if (!contact || !contact.phone || !contact.phone.length)
      return "-";

    let phone = contact.phone.find(phone => phone.isPrimary) || contact.phone[0] || {number:'-'};

    return phone.number;
  }

  getPrimaryAddress(contact) {
    if (!contact || !contact.address || !contact.address.length)
      return "-";

    let address = contact.address.find(adr => adr.isPrimary) || contact.address[0] || {};

    return address.street + "<br/>" + address.city + ' ' + address.state + ', ' + address.zip;
  }

  delete(contact) {
    var that = this;

    var contactText = "<br/><br/><b>" + contact.lastName + "</b><br/><p>" + contact.firstName + "</p>";

    var dlg = this.dialogs.confirm("Delete Contact?", "Do you really want to delete this contact?" + contactText);
    dlg.result.then(() => {
      // OK delete it
      that.ContactService.delete({id: contact._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== contact._id;
          });
        },
        err => {
          alert("Could not delete contact");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.contactList', [uiRouter])
  .config(routes)
  .component('contactList', {
    template: require('./contact-list.html'),
    controller: ContactListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/contact-list/contact-list.component.js